import type { ViewQueryNode } from '@salescore/core'
import { useRecoilValue } from 'recoil'

import type { DeepReadonly } from '../../../rsheet/types/DeepReadonly'
import { sheetCustomModelsAtom } from '../atoms'

// カスタムカラム (SheetCustomModel) はユーザー操作上は「編集」に見えるが、内部では新規子レコード作成 (addChildRecords) として処理される。
// そのため権限チェックを素直に書くと、「レコードの新規作成 = OFF・保存 = ON」のユーザーがカスタムカラムのセルをクリックしただけで
// 「権限がないため、新規レコード作成はできません」警告が出てしまう。
// このフックは対象ノードがカスタムカラム (sheetCustomModelsAtom に含まれる) の場合 true を返し、新規作成を権限不問で許可するバイパス。
// 権限まわりのリファクタでこのバイパスを引き継がないと、カスタムカラムが入力できなくなる回帰が起きる (過去に再発・修正実績あり)。
// なお addRootRecords 側にこのバイパスは無い (ルート行追加は本来の新規レコード作成のため)。
export const useCanBeCreatedWithoutAbility = (): ((recordNode: DeepReadonly<ViewQueryNode>) => boolean) => {
  const sheetCustomModels = useRecoilValue(sheetCustomModelsAtom)
  return (recordNode: DeepReadonly<ViewQueryNode>) => sheetCustomModels.some((x) => x.name === recordNode.name)
}
